module.exports = __webpack_public_path__ + "static/media/laudos.d16cd0f5.jpg";